import React from "react";
// @ts-ignore
import bgTop from "./../Assets/Images/bg-top-profile.svg";
// @ts-ignore
import bgBottom from "./../Assets/Images/bg-bottom.png";
// @ts-ignore
import userBlankImg from "./../Assets/Images/blank-profile-picture.webp";
import { Avatar } from "primereact/avatar";
import { Config } from "../constants/Config";

export interface UserDetails {
  img_path?: string;
  name?: string;
  level_title?: string;
  level_id?: string;
}

export interface Grade {
  id: string;
  title: string;
}

export interface EditProfileProps {
  isLoading: boolean;
  details: UserDetails | null;
  grade: Grade[];
  userGrade: string;
  userName: string;
  onChangeUserName: (name: string) => void;
  onChangeGrade: (gradeId: string) => void;
  onUploadImage: (target: HTMLInputElement) => void;
  onSubmit: () => void;
}

const EditProfile: React.FC<EditProfileProps> = (props) => {
  const {
    isLoading,
    details,
    grade,
    userGrade,
    onChangeUserName,
    onChangeGrade,
    onUploadImage,
    onSubmit,
  } = props;

  return (
    <div className="position-relative">
      <img className="bg-top d-none d-lg-block" src={bgTop} alt="img" />
      <div className="container-xxl my-4">
        <div className="card shadow br-17px p-5 my-5">
          <div className="card-body">
            <div className="row">
              <div className="col-md-2 col-lg-1 text-center text-md-start">
                {isLoading ? (
                  <div className="text-center m-4">
                    <div
                      className="spinner-border spinner-border-sm text-red"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <Avatar
                    image={
                      details?.img_path
                        ? details.img_path.replace(
                            Config.TIPS_THUMBNAIL,
                            Config.TIPS_THUMBNAIL_NEW
                          )
                        : userBlankImg
                    }
                    className="mr-2 wh-99px"
                    size="xlarge"
                    shape="circle"
                  />
                )}
              </div>
              <div className="col-md-7 col-xl-8 ps-lg-5 ps-xl-4 py-md-3 text-center text-md-start">
                <p className="font-21 fw-bold m-0">
                  Welcome back, {details?.name}!
                </p>
                <p className="font-18 text-red m-0">
                  {details?.level_title} Student
                </p>
              </div>
              <div className="col-md-3 py-md-3 mt-3 mt-sm-0 text-center text-md-start">
              </div>
            </div>

            <hr className="my-4" />

            <div className="row align-items-center mt-5 mb-3">
              <div className="col-12 col-md-3 col-xxl-2 mb-3 text-md-center">
                <label className="col-form-label font-15">Full Name</label>
              </div>
              <div className="col-12 col-md-8 mb-4">
                <input
                  type="text"
                  id="fullname"
                  maxLength={15}
                  defaultValue={details?.name || ""}
                  onChange={(event) => {
                    if (event.target.value === " ") {
                      event.target.value = event.target.value.replace(
                        /^[ \t]+|[ \t]+$/gm,
                        ""
                      );
                    } else {
                      onChangeUserName(event.target.value);
                    }
                  }}
                  className="form-control br-5px "
                />
              </div>
            </div>

            <div className="row align-items-center mb-4">
              <div className="col-12 col-md-3 col-xxl-2 mb-3 text-md-center">
                <label className="col-form-label font-15">Grade</label>
              </div>
              <div className="col-12 col-md-8 mb-4">
                <select
                  className="form-select"
                  value={userGrade ? userGrade : details?.level_id || ""}
                  onChange={(event) => {
                    onChangeGrade(event.target.value);
                  }}
                >
                  {grade &&
                    (grade || []).map((data) => {
                      return (
                        <option
                          key={data.id}
                          value={
                            data.title === details?.level_title
                              ? details?.level_id
                              : data.id
                          }
                        >
                          {data.title}
                        </option>
                      );
                    })}
                </select>
              </div>
            </div>

            <div className="row align-items-center mb-5">
              <div className="col-12 col-md-3 col-xxl-2 mb-4 text-md-center">
                <label className="col-form-label font-15">Profile Photo</label>
              </div>

              <div className="col-12 col-md-8 pl-0">
                <div className="row">
                  <div className="col-md-4 col-lg-3 text-center text-md-start">
                    {isLoading ? (
                      <div className="text-center m-5">
                        <div className="spinner-border text-red" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <Avatar
                        image={
                          details?.img_path
                            ? details.img_path.replace(
                                Config.TIPS_THUMBNAIL,
                                Config.TIPS_THUMBNAIL_NEW
                              )
                            : userBlankImg
                        }
                        className="mr-2 wh-150px"
                        size="xlarge"
                        shape="circle"
                      />
                    )}
                  </div>
                  <div className="col-md-8 col-lg-9 py-4 px-md-4 text-center text-md-start">
                    <label
                      htmlFor="file-upload"
                      className="btn btn-red _hover font-14 h-40px mb-2 mt-3 py-2 px-3"
                    >
                      Upload Photo
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept="image/png, image/jpg"
                      name="myImage"
                      onChange={(event) => {
                        onUploadImage(event.target);
                      }}
                    />
                    <p className="m-0 text-small">
                      <small>Maximum size of 1 MB. JPG or PNG.</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-grid gap-2">
              <button
                onClick={onSubmit}
                className="btn btn-red font-14 btn-br _hover h-45px p-10"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <img className="bg-bottom" src={bgBottom} alt="img" />
      <div style={{ height: 150 }}></div>
    </div>
  );
};

export default React.memo(EditProfile);
